import styled from "styled-components";
import { Form } from "react-bootstrap";
import { Campo } from "../../services/tipos";
import { TipoFormulario } from "../../services/constantes";

interface InputColorProps {
    campo: Campo;
    modo: TipoFormulario;
    apenasLeitura?: boolean;
    getFieldValue: (campoNome: string) => string;
    handleInputChange: (nome: string, value: string) => void;
}

const ColorPickerWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`;

const ColorInput = styled(Form.Control)`
    width: 50px;
    height: 40px;
    border: none;
    cursor: pointer;
    background: none;
    padding: 0;

    &::-webkit-color-swatch-wrapper {
        padding: 0;
    }

    &::-webkit-color-swatch {
        border: 2px solid #ccc;
        border-radius: 8px;
        transition: border-color 0.3s;
    }

    &:hover::-webkit-color-swatch {
        border-color: #888;
    }
`;

const ColorCode = styled.span`
    font-family: monospace;
    font-size: 14px;
    color: #555;
`;

export function InputColor(props: InputColorProps) {
    const handleColorChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.currentTarget.value;
        const hexRegex = /^#[0-9A-Fa-f]{6}$/;
        if (hexRegex.test(value)) {
            props.handleInputChange(props.campo.nome, value);
        }
    };

    const isDisabled = (props.apenasLeitura && props.apenasLeitura === true) || (props.modo === TipoFormulario.tpVisualizacao);

    return (
        <ColorPickerWrapper>
            <ColorInput
                type="color"
                disabled={isDisabled}
                required={props.campo.required}
                value={props.getFieldValue(props.campo.nome) || "#000000"}
                onChange={handleColorChange}
                title="Escolha uma cor"
            />
            {!isDisabled && (
                <ColorCode>
                    {props.getFieldValue(props.campo.nome) || "#000000"}
                </ColorCode>
            )}
        </ColorPickerWrapper>
    );
}
